import { render, staticRenderFns } from "./BaseNotFound.vue?vue&type=template&id=37bd8e20&scoped=true&"
import script from "./BaseNotFound.vue?vue&type=script&lang=js&"
export * from "./BaseNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bd8e20",
  null
  
)

export default component.exports